import { AxiosPromise } from 'axios';
import { armorAPI } from '~/services/api';
import { InsuranceSettingsJSON } from '~/types/Insurance';

const get: () => AxiosPromise<InsuranceSettingsJSON> = () => {
  return armorAPI.request({
    url: `/setting/insurance`,
    method: 'GET',
  });
};

const put = (data: InsuranceSettingsJSON) => {
  return armorAPI.request({
    data,
    url: `/setting/insurance`,
    method: 'PUT',
  });
};

export { get, put };
